import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import useModal from '../../../../hooks/useModal';
import ErrorModal from './error/ErrorModal';


const ModalFabric = ({ type, handleClose, error }) => {
  switch (type) {
    case 'blockedError':
      return <ErrorModal error={error} handleClose={handleClose} />;
    default:
      return <></>;
  }
};

const Modal = (props) => {
  const his = useHistory();
  const [history, setHistory] = useState(his.location.pathname);
  const { shown, type, error, close } = props;
  his.listen((location, action) => {
    if (location.pathname !== history) setHistory(location.pathname);
  });

  const { Modal } = useModal(
    'modal flex',
    <ModalFabric type={type} error={error} handleClose={close} />
  );

  return shown ? <Modal /> : null;
};

export default Modal;
